import axios from "axios";

export function getReceiveTransferDeliveryInfo(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/receive-transfer/${uuid}/delivery-info`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
